export default __webpack_public_path__ + "opcommerce.b98831c.png";